import React from 'react';
import { Stack, Text } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import { RoleColumn } from './types';

const borderStyle = ({ theme }: any) => `1px solid ${theme.colors.primary[10]}`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;

  border-top: ${borderStyle};
  border-bottom: ${borderStyle};

  padding: 34px 58px 14px 58px;

  text-align: left;

  .rnp-role-name,
  .rnp-permissions {
    width: 30%;
  }

  .rnp-module {
    width: 30%;
  }

  .rnp-actions {
    width: 10%;
  }
`;

interface Props {
  headerTitles: RoleColumn[];
}

const RolesHeader = ({ headerTitles }: Props) => {
  return (
    <StyledHeader>
      {headerTitles.map((column) => (
        <Stack
          className={column.className}
          flexDirection="column"
          justifyContent="center"
          key={column.title}
        >
          <Text variant="body-large" color="primary.100" weight="light">
            {column.title}
          </Text>
        </Stack>
      ))}
    </StyledHeader>
  );
};

export default RolesHeader;
